import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PasswordChangeMessageService {
    private readonly _messageSubject = new BehaviorSubject<string>('');
    readonly message$ = this._messageSubject.asObservable();

    setMessage(message: string): void {
        this._messageSubject.next(message);
    }

    get message(): string {
        return this._messageSubject.value;
    }
}
